<section
    *ngIf="availableMediaTypes"
    class="agpr-mediaTypeCheckbox"
>
    <div
        *ngIf="enableSelectAll"
        class="ui-g agpr-mediaTypeCheckbox-togglebutton"
    >
        <agpr-button
            *ngIf="!shouldDisableMedia"
            id="mediaTypeCheckbox-toggleButton"
            [style]="buttonTypes.textToggle"
            [label]="mediaTypeIds.length === 0 ? 'selectAll' : 'selectNone'"
            (click)="mediaTypeIds.length === 0 ? selectAll() : unselectAll()"
        ></agpr-button>
    </div>
    <ul
        class="agpr-mediaTypeCheckbox-options"
        [attr.aria-label]="'Monitoring.search.mediaTypes' | localize"
    >
        <li
            *ngFor="let option of otherMediaTypes; index as i;"
            class="agpr-mediaTypeCheckbox-option"
        >
            <agpr-checkbox
                name="group"
                [value]="option.id"
                [id]="'mediaTypeCheckbox-option_' + i"
                [disabled]="!option.isProvisioned || shouldDisableMedia"
                [(ngModel)]="mediaTypeIds"
                (ngModelChange)="onCheckboxUpdate()"
                styleClass="agpr-mediaTypeCheckbox-checkbox"
                [ariaDescribedBy]="ariaDescribedBy"
            >
                <span
                    aria-hidden="true"
                    class="agpr-mediaTypeCheckbox-mediaIcon"
                    [class.agpr-mediaTypeCheckbox-mediaIcon--disabled]="!option.isProvisioned"
                    [ngClass]="option.icon"
                ></span>
                <span
                    class="agpr-mediaTypeCheckbox-label"
                    [class.agpr-mediaTypeCheckbox-label--disabled]="!option.isProvisioned"
                >
                    {{ option.name | localize }}
                </span>
                <span
                    *ngIf="!option.isProvisioned"
                    class="agpr-mediaTypeCheckbox-socialMediaSubscriptionsIcon agpr-lock-icon fa-solid fa-lock"
                    [agprTooltip]="'MediaTypeCheckbox.notProvisionedIconToolTip' | localize: {mediaType: option.name}"
                ></span>
            </agpr-checkbox>
        </li>
    </ul>
    <div
        role="group"
        class="agpr-mediaTypeCheckbox-socialMedia"
        aria-labelledby="mediaTypeCheckbox.broadcast"
    >
        <span
            id="mediaTypeCheckbox.broadcast"
            class="agpr-mediaTypeCheckbox-socialMediaHeading">
            {{ 'Monitoring.search.broadcast' | localize }}
        </span>
        <span
            *ngIf="hasTvEyes && hasSubscriptions"
            class="agpr-mediaTypeCheckbox-socialMediaSubscriptions"
        >
            <a
                id="mediaTypeCheckbox-socialMediaHeading-manageSubscriptions"
                class="agpr-mediaTypeCheckbox-socialMediaSubscriptionsLink agpr-link"
                tabindex="0"
                (keydown)="goToManageSubscriptions($event)"
                (click)="goToManageSubscriptions()"
            >
                {{'MediaTypeCheckbox.manageSubscriptions'| localize}}
            </a>
            <span
                role="img"
                class="agpr-mediaTypeCheckbox-socialMediaSubscriptionsIcon fa-regular fa-circle-info"
                agprTooltip="MediaTypeCheckbox.manageSubscriptionsIconToolTip"
            ></span>
        </span>
        <ul class="agpr-mediaTypeCheckbox-options">
            @for (option of broadcastMediaTypes; track option.id; let i = $index) {
                <li class="agpr-mediaTypeCheckbox-option agpr-mediaTypeCheckbox-option--column">
                    <agpr-checkbox
                        name="group"
                        [id]="'mediaTypeCheckbox-broadcastOptions_' + i"
                        styleClass="agpr-mediaTypeCheckbox-checkbox"
                        [value]="option.id"
                        [(ngModel)]="mediaTypeIds"
                        (ngModelChange)="onCheckboxUpdate()"
                        [disabled]="option.isDisabled || !option.isProvisioned || shouldDisableMedia"
                        [ariaDescribedBy]="ariaDescribedBy"
                    >
                        <span
                            aria-hidden="true"
                            class="agpr-mediaTypeCheckbox-mediaIcon"
                            [class.agpr-mediaTypeCheckbox-mediaIcon--disabled]="!option.isProvisioned"
                            [ngClass]="option.icon"
                        ></span>
                        <span
                            class="agpr-mediaTypeCheckbox-label"
                            [class.agpr-mediaTypeCheckbox-label--disabled]="!option.isProvisioned"
                        >
                            {{ option.name | localize }}
                        </span>
                        <span
                            *ngIf="!option.isProvisioned"
                            class="agpr-mediaTypeCheckbox-socialMediaSubscriptionsIcon agpr-lock-icon fa-solid fa-lock"
                            [agprTooltip]="'MediaTypeCheckbox.notProvisionedIconToolTip' | localize: {mediaType: option.name}"
                        ></span>
                    </agpr-checkbox>

                    @if (option.id === mediaTypes.TV && isTvChecked) {
                        <ul class="agpr-mediaTypeCheckbox-options agpr-mediaTypeCheckbox-options--sub">
                            @for (subOption of tvSubTypes; track subOption.childId; let j = $index) {
                                <li class="agpr-mediaTypeCheckbox-option">
                                    <agpr-checkbox
                                        [name]="`${option.id}_subGroup`"
                                        [id]="`mediaTypeCheckbox-broadcastOptions_${i}_${j}`"
                                        styleClass="agpr-mediaTypeCheckbox-checkbox"
                                        [infoCircleTooltip]="subOption.childId === broadcastSubTypes.ADVERTISEMENT ? 'MediaTypeCheckbox.broadcast.advertisement.tooltip' : ''"
                                        [value]="subOption.childId"
                                        [(ngModel)]="tvSubTypeIds"
                                        (ngModelChange)="onCheckboxUpdate()"
                                        [disabled]="option.isDisabled || !option.isProvisioned || shouldDisableMedia"
                                        [ariaDescribedBy]="hasBroadcastSubTypeError ? 'broadcastSubType_error' : ariaDescribedBy"
                                    >
                                        <span
                                            class="agpr-mediaTypeCheckbox-label"
                                            [class.agpr-mediaTypeCheckbox-label--disabled]="!option.isProvisioned"
                                        >
                                            {{ subOption.name | localize }}
                                        </span>
                                    </agpr-checkbox>
                                </li>
                            }
                        </ul>
                    }
                </li>
            }
        </ul>
        @if (hasBroadcastSubTypeError) {
            <agpr-form-message [id]="'broadcastSubType_error'">
                {{ 'MediaTypeCheckbox.broadcast.required' | localize }}
            </agpr-form-message>
        }
    </div>
    <div
        class="agpr-mediaTypeCheckbox-socialMedia"
        role="group"
        aria-labelledby="mediaTypeCheckbox.social"
    >
        <span
            id="mediaTypeCheckbox.social"
            class="agpr-mediaTypeCheckbox-socialMediaHeading"
        >
            {{ 'Monitoring.search.social' | localize }}
        </span>
        <span
            *ngIf="hasSubscriptions && !hasSocial"
            class="agpr-mediaTypeCheckbox-socialMediaSubscriptions"
        >
            <a
                id="mediaTypeCheckbox-socialMediaHeading-manageSubscriptions"
                class="agpr-mediaTypeCheckbox-socialMediaSubscriptionsLink agpr-link"
                tabindex="0"
                (keydown)="goToManageSubscriptions($event)"
                (click)="goToManageSubscriptions()"
            >{{'MediaTypeCheckbox.manageSubscriptions'| localize}}</a>
            <span
                role="img"
                class="agpr-mediaTypeCheckbox-socialMediaSubscriptionsIcon fa-regular fa-circle-info"
                agprTooltip="MediaTypeCheckbox.manageSubscriptionsIconToolTip"
            ></span>
        </span>
        <span
            *ngIf="hasSocial"
            class="agpr-mediaTypeCheckbox-socialMediaSubscriptions"
        >
            <a
                id="mediaTypeCheckbox-socialMediaHeading-manageSocialTopics"
                class="agpr-mediaTypeCheckbox-socialMediaSubscriptionsLink agpr-link"
                tabindex="0"
                (keydown)="goToManageSocialTopics($event)"
                (click)="goToManageSocialTopics()"
            >
                {{ 'MediaTypeCheckbox.manageSocialTopics'| localize }}
            </a>
            <span
                role="img"
                class="agpr-mediaTypeCheckbox-socialMediaSubscriptionsIcon fa-regular fa-circle-info"
                agprTooltip="MediaTypeCheckbox.tooltip.manageSocialTopics"
            ></span>
        </span>
        <ul class="agpr-mediaTypeCheckbox-options">
            <li
                *ngFor="let option of socialMediaTypes; index as i"
                class="agpr-mediaTypeCheckbox-option"
            >
                <agpr-checkbox
                    name="group"
                    [value]="option.id"
                    [id]="'mediaTypeCheckbox-socialOptions_' + i"
                    [disabled]="option.isDisabled || !option.isProvisioned || shouldDisableMedia"
                    [(ngModel)]="mediaTypeIds"
                    (ngModelChange)="onCheckboxUpdate()"
                    styleClass="agpr-mediaTypeCheckbox-checkbox"
                    [ariaDescribedBy]="ariaDescribedBy"
                >
                    <span
                        aria-hidden="true"
                        class="agpr-mediaTypeCheckbox-mediaIcon"
                        [class.agpr-mediaTypeCheckbox-mediaIcon--disabled]="!option.isProvisioned"
                        [ngClass]="option.icon"
                    ></span>
                    <span
                        class="agpr-mediaTypeCheckbox-label"
                        [class.agpr-mediaTypeCheckbox-label--disabled]="!option.isProvisioned"
                    >
                        {{ option.name | localize }}
                    </span>
                    <span
                        *ngIf="!option.isProvisioned"
                        class="agpr-mediaTypeCheckbox-socialMediaSubscriptionsIcon agpr-lock-icon fa-solid fa-lock"
                        [agprTooltip]="'MediaTypeCheckbox.notProvisionedIconToolTip' | localize: {mediaType: option.name}"
                    ></span>
                </agpr-checkbox>
            </li>
        </ul>
    </div>
    <agpr-panel
        *ngIf="isSavedSearch"
        class="agpr-mediaTypeCheckbox-other-savedSearch"
        role="group"
        aria-labelledby="mediaTypeCheckbox_savedSearch"
        [collapsed]="savedSearchMediaTypesCollapsed"
    >
        <ng-template #panelHeader>
            <span
                id="mediaTypeCheckbox_savedSearch"
                class="agpr-mediaTypeCheckbox-savedSearchHeading"
            >
                {{ 'Monitoring.search.other' | localize }}
            </span>
            <span
                role="img"
                class="fa-regular fa-circle-info"
                agprTooltip="Monitoring.search.social.tooltip"
            ></span>
        </ng-template>

        <ul class="agpr-mediaTypeCheckbox-options">
            <li
                *ngFor="let option of savedSearchSocialMediaTypes; index as i"
                class="agpr-mediaTypeCheckbox-option"
            >
                <agpr-checkbox
                    name="group"
                    [value]="option.id"
                    [id]="'mediaTypeCheckbox-socialOptions_' + i"
                    [disabled]="option.isDisabled || !option.isProvisioned || shouldDisableMedia"
                    [(ngModel)]="mediaTypeIds"
                    (ngModelChange)="onCheckboxUpdate()"
                    styleClass="agpr-mediaTypeCheckbox-checkbox"
                    [ariaDescribedBy]="ariaDescribedBy"
                >
                    <span
                        aria-hidden="true"
                        class="agpr-mediaTypeCheckbox-mediaIcon"
                        [class.agpr-mediaTypeCheckbox-mediaIcon--disabled]="!option.isProvisioned"
                        [ngClass]="option.icon"
                    ></span>
                    <span
                        class="agpr-mediaTypeCheckbox-label"
                        [class.agpr-mediaTypeCheckbox-label--disabled]="!option.isProvisioned"
                    >
                        {{ option.name | localize }}
                    </span>
                </agpr-checkbox>
            </li>
            <li
                *ngIf="!!magazineMediaType"
                class="agpr-mediaTypeCheckbox-option-other"
            >
                <agpr-checkbox
                    name="group"
                    [value]="magazineMediaType.id"
                    [id]="'mediaTypeCheckbox-socialOptions_' + i"
                    [disabled]="magazineMediaType.isDisabled || !magazineMediaType.isProvisioned || shouldDisableMedia"
                    [(ngModel)]="mediaTypeIds"
                    (ngModelChange)="onCheckboxUpdate()"
                    styleClass="agpr-mediaTypeCheckbox-checkbox"
                    [ariaDescribedBy]="ariaDescribedBy"
                >
                    <span
                        aria-hidden="true"
                        class="agpr-mediaTypeCheckbox-mediaIcon"
                        [class.agpr-mediaTypeCheckbox-mediaIcon--disabled]="!magazineMediaType.isProvisioned"
                        [ngClass]="magazineMediaType.icon"
                    ></span>
                    <span
                        class="agpr-mediaTypeCheckbox-label"
                        [class.agpr-mediaTypeCheckbox-label--disabled]="!magazineMediaType.isProvisioned"
                    >
                        {{ magazineMediaType.name | localize }}
                    </span>
                </agpr-checkbox>
            </li>
            <li
                *ngIf="!!otherMediaType"
                class="agpr-mediaTypeCheckbox-option-other"
            >
                <agpr-checkbox
                    name="group"
                    [value]="otherMediaType.id"
                    [id]="'mediaTypeCheckbox-socialOptions_' + i"
                    [disabled]="otherMediaType.isDisabled || !otherMediaType.isProvisioned || shouldDisableMedia"
                    [(ngModel)]="mediaTypeIds"
                    (ngModelChange)="onCheckboxUpdate()"
                    styleClass="agpr-mediaTypeCheckbox-checkbox"
                    [ariaDescribedBy]="ariaDescribedBy"
                >
                    <span
                        aria-hidden="true"
                        class="agpr-mediaTypeCheckbox-mediaIcon"
                        [class.agpr-mediaTypeCheckbox-mediaIcon--disabled]="!otherMediaType.isProvisioned"
                        [ngClass]="otherMediaType.icon"
                    ></span>
                    <span
                        class="agpr-mediaTypeCheckbox-label"
                        [class.agpr-mediaTypeCheckbox-label--disabled]="!otherMediaType.isProvisioned"
                    >
                        {{ otherMediaType.name | localize }}
                    </span>
                </agpr-checkbox>
            </li>
        </ul>
    </agpr-panel>
</section>
<section
    *ngIf="!availableMediaTypes"
    class="agpr-mediaTypeCheckbox--loading"
    [agprLoading]="true"
></section>
